export const simulateKeyUp = (code: string) => (e: any) => {
  window.dispatchEvent(
    new KeyboardEvent('keyup', {
      key: code,
      code, // put everything you need in this object.
      shiftKey: false, // you don't need to include values
      ctrlKey: false, // if you aren't going to use them.
      metaKey: false, // these are here for example's sake.
    }),
  );
};
